/**
 * GNK 2026 본예산 수입편성 이관 (gnk_bbud2.md)
 * 금액: legacyBudgetAmtWon·calcAmt 원천은 원 → 부트스트랩에서 천원(수입 절사) 변환
 * 마스터 7건 · 디테일 22건
 */
export const GNK_INCOME_REQUEST_ROWS = [
  {
    deptCode: 'GNK1010',
    deptName: '예산기획팀',
    bizName: '전년도이월금',
    sehangName: '이월금',
    mokName: '전년도이월금',
    semokName: '전년도이월금(법인후원금)',
    legacyBudgetAmtWon: 33168990000,
    details: [
      {
        calcLevel: 1,
        calcDesc: '법전 이월금',
        calcBasis: '33168990000',
        calcAmtWon: 33168990000,
        remark: '',
      },
    ],
  },
  {
    deptCode: 'GNK1040',
    deptName: '예산운영부',
    bizName: '기타예금이자 수입',
    sehangName: '잡수입',
    mokName: '기타예금이자 수입',
    semokName: '이자수입(본부)',
    legacyBudgetAmtWon: 382140000,
    details: [
      {
        calcLevel: 1,
        calcDesc: '[예금이자수익]',
        calcBasis: '',
        calcAmtWon: 382140000,
        remark: '',
      },
      {
        calcLevel: 2,
        calcDesc: '1) MMT 및 보통예금 이자수입',
        calcBasis: '18,447,000원*12개월',
        calcAmtWon: 221364000,
        remark: '',
      },
      {
        calcLevel: 2,
        calcDesc: '2) 퇴직예금+MMT',
        calcBasis: '58,000원*12개월',
        calcAmtWon: 696000,
        remark: '',
      },
      {
        calcLevel: 2,
        calcDesc: '3) 기본재산 정기예금 이자수익',
        calcBasis: '35,080,000원',
        calcAmtWon: 35080000,
        remark: '',
      },
      {
        calcLevel: 2,
        calcDesc: '4) 단기금융상품 이자수익',
        calcBasis: '125,000,000원',
        calcAmtWon: 125000000,
        remark: '',
      },
    ],
  },
  {
    deptCode: 'GNK1040',
    deptName: '예산운영부',
    bizName: '기타예금이자 수입',
    sehangName: '잡수입',
    mokName: '기타예금이자 수입',
    semokName: '이자수입(퇴직연금운용수익)',
    legacyBudgetAmtWon: 966372000,
    details: [
      {
        calcLevel: 1,
        calcDesc: '[퇴직연금 운용수익]',
        calcBasis: '966,372,000원',
        calcAmtWon: 966372000,
        remark: '',
      },
    ],
  },
  {
    deptCode: 'GNK1140',
    deptName: '후원서비스팀',
    bizName: '정기후원금',
    sehangName: '후원금수입',
    mokName: '정기후원금',
    semokName: '정기후원금',
    legacyBudgetAmtWon: 24483997000,
    details: [
      {
        calcLevel: 1,
        calcDesc: '목표액',
        calcBasis: '24483997000',
        calcAmtWon: 24483997000,
        remark: '',
      },
    ],
  },
  {
    deptCode: 'GNK1230',
    deptName: '사회공헌협력센터',
    bizName: '지정후원금(본부)',
    sehangName: '후원금수입',
    mokName: '지정후원금(본부)',
    semokName: '지정후원금(본부)',
    legacyBudgetAmtWon: 18112000000,
    details: [
      { calcLevel: 1, calcDesc: '1월', calcBasis: '1,799,750,000', calcAmtWon: 1799750000, remark: '' },
      { calcLevel: 1, calcDesc: '2월', calcBasis: '3,519,750,000', calcAmtWon: 3519750000, remark: '' },
      { calcLevel: 1, calcDesc: '3월', calcBasis: '104,750,000', calcAmtWon: 104750000, remark: '' },
      { calcLevel: 1, calcDesc: '4월', calcBasis: '804,750,000', calcAmtWon: 804750000, remark: '' },
      { calcLevel: 1, calcDesc: '5월', calcBasis: '5,419,750,000', calcAmtWon: 5419750000, remark: '' },
      { calcLevel: 1, calcDesc: '6월', calcBasis: '19,750,000', calcAmtWon: 19750000, remark: '' },
      { calcLevel: 1, calcDesc: '7월', calcBasis: '769,750,000', calcAmtWon: 769750000, remark: '' },
      { calcLevel: 1, calcDesc: '8월', calcBasis: '319,750,000', calcAmtWon: 319750000, remark: '' },
      { calcLevel: 1, calcDesc: '9월', calcBasis: '2,463,500,000', calcAmtWon: 2463500000, remark: '' },
      { calcLevel: 1, calcDesc: '10월', calcBasis: '463,500,000', calcAmtWon: 463500000, remark: '' },
      { calcLevel: 1, calcDesc: '11월', calcBasis: '2,313,500,000', calcAmtWon: 2313500000, remark: '' },
      { calcLevel: 1, calcDesc: '12월', calcBasis: '113,500,000', calcAmtWon: 113500000, remark: '' },
    ],
  },
  {
    deptCode: 'GNK1240',
    deptName: '물품후원팀',
    bizName: '후원물품',
    sehangName: '후원금수입',
    mokName: '후원물품',
    semokName: '후원물품(본부)',
    legacyBudgetAmtWon: 3500000000,
    details: [
      {
        calcLevel: 1,
        calcDesc: '2026년 물품후원팀 후원물품(본부) 개발 목표',
        calcBasis: '3,500,000,000원*1년',
        calcAmtWon: 3500000000,
        remark: '',
      },
    ],
  },
  {
    deptCode: 'GNK1250',
    deptName: '특별후원팀',
    bizName: '지정후원금(본부)',
    sehangName: '후원금수입',
    mokName: '지정후원금(본부)',
    semokName: '지정후원금(본부)',
    legacyBudgetAmtWon: 300000000,
    details: [
      {
        calcLevel: 1,
        calcDesc: '목표액',
        calcBasis: '300000000',
        calcAmtWon: 300000000,
        remark: '',
      },
    ],
  },
];
